var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDocsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36v36h-36z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.875 16.875h14.25v2.625h-14.25z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.875 21.375h10.5v2.625h-10.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.75 8.25 4.524375.855 3.725625-.855-8.25-8.25-1.138125 3.91125z",
    fill: "#1967d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.875 12.375h14.25v2.625h-14.25z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.75 8.25v-8.25h-13.5c-1.243125 0-2.25 1.006875-2.25 2.25v28.5c0 1.243125 1.006875 2.25 2.25 2.25h19.5c1.243125 0 2.25-1.006875 2.25-2.25v-22.5zm-.75 15.375h-9.75v-1.875h9.75zm3.75-4.5h-13.5v-1.875h13.5zm0-4.5h-13.5v-1.875h13.5z",
    fill: "#4285f4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocsIcon);
export default __webpack_public_path__ + "static/media/google-docs-icon.bcfa2c72756723df6246b898653d04c9.svg";
export { ForwardRef as ReactComponent };